import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { Card, Tag, Button } from "antd";
import { ApiOutlined } from "@ant-design/icons";
import Breadcrumb from "../../components/Breadcrumb";
import Spinner from "../../components/Spinner";
import { GET_FUB_SETTINGS } from "../../graphql/fubSettingQueries";

const AgentIntegrations = () => {
  const { companyId } = useParams();
  const navigate = useNavigate();

  const { data: fubData, loading: fubLoading } = useQuery(GET_FUB_SETTINGS, {
    variables: { companyId },
    fetchPolicy: "network-only",
  });

  const isConnected = fubData?.getFubSettings?.isConnected;

  if (fubLoading) return <Spinner />;

  return (
    <div className="m-4">
      <Breadcrumb
        title="Integrations"
        items={[
          { title: "Dashboard", href: `/company/${companyId}/agent/dashboard` },
          { title: "Integrations" },
        ]}
      />

      <div className="mt-6">
        <h3 className="text-lg font-semibold text-gray-700 mb-2">
          CRM Integrations
        </h3>
        <p className="text-gray-500 text-sm mb-6">
          Connect your CRM to automatically sync buyers and property search
          criteria.
        </p>

        <Card
          hoverable
          className={`max-w-md ${isConnected ? "cursor-pointer" : ""}`}
          onClick={() =>
            isConnected &&
            navigate(
              `/company/${companyId}/agent/integrations/fub/buyer-pool`
            )
          }
        >
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div className="flex min-w-[14rem] flex-1 items-center gap-4">
              <div className="bg-blue-100 p-3 rounded-lg">
                <ApiOutlined className="text-2xl text-blue-600" />
              </div>
              <div>
                <h3 className="text-lg font-semibold m-0">Follow Up Boss</h3>
                <p className="text-gray-500 text-sm m-0 mt-1">
                  Automatically sync buyers and property search criteria.
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2 sm:flex-col sm:items-end">
              <Tag color={isConnected ? "green" : "default"}>
                {isConnected ? "Connected" : "Not Connected"}
              </Tag>
              {isConnected ? (
                <Button
                  type="primary"
                  size="small"
                  style={{
                    backgroundColor: "#b4c540",
                    borderColor: "#b4c540",
                  }}
                >
                  View Buyer Pool
                </Button>
              ) : (
                <Button size="small" disabled>
                  Not Available
                </Button>
              )}
            </div>
          </div>
          {!isConnected && (
            <p className="text-gray-400 text-xs mt-3 mb-0">
              Contact your administrator to enable this integration.
            </p>
          )}
        </Card>
      </div>
    </div>
  );
};

export default AgentIntegrations;
